module.exports = __webpack_public_path__ + "img/next.e6391dc9.svg";